/** List of employees */
export const GET_EMPLEADOS_LIST_REQUEST = 'GET_EMPLEADOS_LIST_REQUEST';
export const GET_EMPLEADOS_LIST_SUCCESS = 'GET_EMPLEADOS_LIST_SUCCESS';
export const SEND_MAIL_EMPLEADOS_REQUEST ='SEND_MAIL_EMPLEADOS_REQUEST';
export const SEND_MAIL_EMPLEADOS_SUCCESS = 'SEND_MAIL_EMPLEADOS_SUCCESS';
export const SEND_MAIL_EMPLEADOS_ERROR = 'SEND_MAIL_EMPLEADOS_ERROR';

/** Empleados form */
export const SET_EMPLEADO_REQUEST = 'SET_EMPLEADO_REQUEST';
export const SET_EMPLEADO_SUCCESS = 'SET_EMPLEADO_SUCCESS';
export const SHOW_ADD_EMPLEADO_MODAL = 'SHOW_EMPLEADO_MODAL';
export const HIDE_ADD_EMPLEADO_MODAL = 'HIDE_ADD_EMPLEADO_MODAL';

/** Empleados files */
export const SET_FILES_EMPLEADOS = 'SET_FILES_EMPLEADOS';
export const SET_UPLOAD_FILES_EMPLEADO_REQUEST = 'SET_UPLOAD_FILES_EMPLEADO_REQUEST';
export const SET_UPLOAD_FILES_EMPLEADO_SUCCESS = 'SET_UPLOAD_FILES_EMPLEADO_SUCCESS';
export const GET_FILES_REQUEST = 'GET_FILES_REQUEST';
/** Error */
export const GET_EMPLEADOS_ERROR = 'GET_EMPLEADOS_ERROR';

